import SparkMD5 from "spark-md5";

const AvatarMixin = {
	methods: {
		getAvatar: function(id = 1) {
			return `https://i.pravatar.cc/300?img=${id}`;
		},
		getGravatar(email) {
			return (
				`https://www.gravatar.com/avatar/${SparkMD5.hash(email)}` +
				`?d=${encodeURIComponent("https://fylm.ai/wp-content/uploads/2020/10/colordio-site-logo-black-small-x2.png")}`
			);
		},
	},
};

export default AvatarMixin;
